import * as React from "react"
import type { SVGProps } from "react"
const SvgPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 17.75V7.4q0-.43.3-.72a1 1 0 0 1 .96-.25q.14.04.27.12l8.15 5.17q.23.15.33.38a1 1 0 0 1 0 .95 1 1 0 0 1-.34.37L9.53 18.6a1 1 0 0 1-.52.15 1 1 0 0 1-.7-.3 1 1 0 0 1-.3-.7m2-1.83 5.25-3.35L10 9.22z" />
  </svg>
)
export default SvgPlay
